import React from "react";
import { shallowEqual, useSelector } from 'react-redux';
import { Link, Redirect, Route, Switch } from "react-router-dom";
import Login from "./Login";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import * as routerHelpers from "../../router/RouterHelpers";

export default function AuthPage() {

  const { branding } = useSelector(
      ({ branding}) => ({
        branding
      }),
      shallowEqual
  );

  return (
      <>
        <div className="kt-grid kt-grid--ver kt-grid--root">
          <div
              id="kt_login"
              className="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v1"
          >
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
              <div
                  className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-3.jpg")})`
                  }}
              >
                <div className="kt-grid__item">
                  <Link to="/" className="kt-login__logo">
                    <img
                        alt="Logo"
                        src={toAbsoluteUrl("/media/logos/logo.png")}
                    />
                  </Link>
                </div>
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                  <div className="kt-grid__item kt-grid__item--middle">
                    <h3 className="kt-login__title">Bem-vindo ao sistema {branding.software_name}</h3>
                    <h4 className="kt-login__subtitle">
                      {branding.software_slogan}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
                <Switch>
                  <Redirect from="/auth" exact={true} to="/auth/login" />

                  <Route path="/auth/login" component={Login} />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}
